var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 8C7.99468 8 8.94851 7.60491 9.65177 6.90165C10.355 6.19839 10.7501 5.24456 10.7501 4.25C10.7501 3.25544 10.355 2.30161 9.65177 1.59835C8.94851 0.895088 7.99468 0.5 7.00012 0.5C6.00556 0.5 5.05173 0.895088 4.34847 1.59835C3.64521 2.30161 3.25012 3.25544 3.25012 4.25C3.25012 5.24456 3.64521 6.19839 4.34847 6.90165C5.05173 7.60491 6.00556 8 7.00012 8ZM7.00012 9.875C3.24262 9.875 0.182617 12.395 0.182617 15.5C0.182617 15.71 0.347617 15.875 0.557617 15.875H13.4426C13.6526 15.875 13.8176 15.71 13.8176 15.5C13.8176 12.395 10.7576 9.875 7.00012 9.875Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4ae93b95969358194b794fb4b2db0450.svg";
export { ForwardRef as ReactComponent };